import { Injectable } from '@angular/core';

import {
  convertSrtToVtt,
  vttHasCues,
} from 'src/app/template-editor/template-components/utils/srt-to-vtt';
import { FileItem } from './file-uploader.service';

@Injectable({
  providedIn: 'root',
})
export class SrtConverterService {
  convert(fileItem: FileItem): Promise<void> {
    return new Promise((resolve) => {
      if (!fileItem.file?.name?.toLowerCase().endsWith('.srt')) {
        return resolve();
      }

      fileItem.conversionError = undefined;

      const reader = new FileReader();

      reader.onerror = () => {
        fileItem.conversionError = 'Could not read the subtitle file.';
        resolve();
      };

      reader.onload = (e) => {
        try {
          const vttContent = convertSrtToVtt(e.target.result as string);

          if (!vttHasCues(vttContent)) {
            fileItem.conversionError =
              'This file does not appear to be a valid SRT subtitle file.';
            return resolve();
          }

          fileItem.domFileItem = new Blob([vttContent], { type: 'text/vtt' });
          fileItem.file.size = fileItem.domFileItem.size;
          fileItem.file.type = 'text/vtt';
          fileItem.file.name = fileItem.file.name.replace(/\.srt$/i, '.vtt');

          resolve();
        } catch {
          fileItem.conversionError =
            'An error occurred while converting the subtitle file.';
          resolve();
        }
      };

      reader.readAsText(fileItem.domFileItem);
    });
  }
}
